import { render, staticRenderFns } from "./AgreementDetails.vue?vue&type=template&id=474b517e&scoped=true&"
import script from "./AgreementDetails.vue?vue&type=script&lang=ts&"
export * from "./AgreementDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b517e",
  null
  
)

export default component.exports